<template>
    <div class="col-sm-12 px-3">
        <div class="row" v-if="!disableAdd">
            <div class="data-list-item add col-sm-12" @click.stop="$emit('add')">
                <div class="item-img-cont add-title">
                    <i class="fa fa-plus" />
                </div>
                <div class="item-text-cont">
                    <span class="item-title-add">{{ $t('common.add_new') }}</span>
                    <font-awesome-icon icon="clipboard-check" class="card-body-icon" />
                </div>
            </div>
        </div>

        <Transition name="fade">
            <div class="row">
                <div v-if="templates.length > 0" class="list-content nopads mt-4" style="padding: 0 !important;">
                    <vue3-datatable
                        ref="resultTable"
                        :rows="templates"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                        @row-click="emitEdit"
                    >
                        <template #empty>
                            <div class="text-center my-2">
                                {{ $t('area_report.no_results') }}
                            </div>
                        </template>
                    </vue3-datatable>
                </div>

            </div>
        </Transition>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'MvrInspectionTemplatesList',
    components: {Vue3Datatable},
    mixins: [restApi],
    props: {
        disableAdd: {
            type: Boolean,
            default: false
        },
        loadInspectables: {
            type: Boolean,
            default: false
        },
        defaultTemplates: {
            type: Array,
            default: () => []
        },
    },
    data: function () {
        return {
            loading: false,
            templates: [],
            fields: [
                {field: 'name', title: this.$t('inspectable_editor.name'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        defaultTemplates: {
            handler: function (val) {
                this.templates = val
            },
            deep: true
        }
    },
    mounted() {
        if(this.loadInspectables) {
            this.fetchTemplates()
        } else {
            this.templates = this.defaultTemplates
        }
    },
    methods: {
        fetchTemplates() {
            this.loading = true
            this.restFetch(this.mvrInspectionTemplateseUrl, (response) => {
                this.templates = response.data
                this.loading = false
            }, () => {
                this.loading = false
            })
        },
        emitEdit(inspectionTemplate) {
            this.$emit('selected', inspectionTemplate)
        }
    }
}
</script>
